var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social icon",
    opacity: 0.4,
    clipPath: "url(#clip0_1802_55000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.6016 5.15312C19.4885 4.72764 19.2657 4.33931 18.9554 4.027C18.6451 3.7147 18.2582 3.48938 17.8334 3.37358C16.2698 2.95313 10.0198 2.95312 10.0198 2.95312C10.0198 2.95312 3.76978 2.95313 2.20614 3.37358C1.78138 3.48938 1.39449 3.7147 1.08418 4.027C0.773872 4.33931 0.55103 4.72764 0.437957 5.15312C0.0197754 6.72358 0.0197754 9.99858 0.0197754 9.99858C0.0197754 9.99858 0.0197754 13.2736 0.437957 14.844C0.55103 15.2695 0.773872 15.6578 1.08418 15.9702C1.39449 16.2825 1.78138 16.5078 2.20614 16.6236C3.76978 17.044 10.0198 17.044 10.0198 17.044C10.0198 17.044 16.2698 17.044 17.8334 16.6236C18.2582 16.5078 18.6451 16.2825 18.9554 15.9702C19.2657 15.6578 19.4885 15.2695 19.6016 14.844C20.0198 13.2736 20.0198 9.99858 20.0198 9.99858C20.0198 9.99858 20.0198 6.72358 19.6016 5.15312Z",
    fill: "#FF0302"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.97449 12.9712V7.02344L13.2018 9.9973L7.97449 12.9712Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1802_55000"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialTableIcon);
export default __webpack_public_path__ + "static/media/SocialTableIcon.667a083ccfe98ee3f4450a9113c01754.svg";
export { ForwardRef as ReactComponent };